
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TeacherListeningBadge extends Vue {
  @Prop({ type: Boolean, required: true }) readonly isListening!: boolean;
  @Prop({ type: Boolean, required: true }) readonly isSpeaking!: boolean;
  @Prop({ type: Boolean, required: true }) readonly isChatButtonDisplayed!: boolean;
  @Prop({ type: Boolean, required: true }) readonly showActionButtons!: boolean;
  @Prop({ type: Boolean, required: true }) readonly isConvDisplayed!: boolean;
  @Prop({ type: Boolean, required: true }) readonly isInPlayer!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isListeningNotes!: boolean;

  get isVisible() {
    return (this.isListening || this.isListeningNotes) && this.isChatButtonDisplayed && !this.showActionButtons && !this.isConvDisplayed;
  }
}
